/**
 * Status page
 *
 */
'use strict'

var App = require('app')
var Marionette = require('marionette')
var _ = require('lodash')
var View = require('./view.js')

var List = function () {
  var Controller = Marionette.Object.extend({
    initialize: function () {
      var self = this

      // retrieve client entity
      self.client = App.globalChannel.request('client:entity', App.session.user.get('client'))

      // retrieve geo entities for the map
      self.devicesGeo = App.globalChannel.request('device:geo:entities')
      self.devicesGeo.fetch()

      // listen for device updates
      // App.globalChannel.on('devices:event:updated', _.bind(self.onRemoteDeviceUpdated, self))

      // initialize layout
      self.layout = self.getLayoutView(self.client)

      self.layout.on('render', function () {
        self.systemRegion()
        self.mapRegion()
      })

      App.rootLayout.getRegion('mainRegion').reset()
      App.rootLayout.getRegion('mainRegion').show(self.layout)
    },
    /* Regions --------------------------------------------------------------- */

    /**
     * System region
     * Shows system status etc.
     */
    systemRegion: function () {
      var self = this
      var systemLayout = self.getSystemLayout(self.client)
      self.layout.showChildView('systemRegion', systemLayout)
    },
    /**
     * Map region
     * Displays the map
     */
    mapRegion: function () {
      var self = this
      App.globalChannel.trigger('devices:map', { devicesGeo: self.devicesGeo, region: self.layout.getRegion('mapRegion') })
    },
    /* Events */
    // onRemoteDeviceUpdated: function (data) {
    //   if (!this.devicesCollection) return false
    //
    //   var device = this.devicesCollection.get(data._id)
    //   if (!device) return false
    //   device.set(data)
    // },

    /* Views ----------------------------------------------------------------- */
    getLayoutView: function (model) {
      return new View.Layout({model: model})
    },
    getSystemLayout: function (model) {
      return new View.SystemLayout({model: model})
    }
  })

  return new Controller()
}

module.exports = List



// WEBPACK FOOTER //
// ./js/modules/page-status/show/index.js